module.exports = __webpack_public_path__ + "90D8CADA833262A7add.bc04aad9.png";